// extracted by mini-css-extract-plugin
export var addViewLink = "_c-1";
export var availabilityIcon = "_c-16";
export var availabilitySelectionIcon = "_c-15";
export var backButton = "_c-2";
export var backIcon = "_c-z";
export var conversationCount = "_c-3";
export var dragHandle = "_c-5";
export var dropdown = "_c-e";
export var dropdownIcon = "_c-7";
export var dropdownOption = "_c-6";
export var dropdownTriangle = "_c-d";
export var expand = "_c-f";
export var folder = "_c-i";
export var folderItem = "_c-c";
export var icon = "_c-8";
export var iconRow = "_c-9";
export var image = "_c-a";
export var logo = "_c-b";
export var navContainer = "_c-h";
export var navigationFooter = "_c-g";
export var pageShell = "_c-0";
export var placeholderAvailable = "_c-11";
export var placeholderBox = "_c-14";
export var placeholderBusy = "_c-13";
export var placeholderUnavailable = "_c-12";
export var profile = "_c-k";
export var profileContainer = "_c-m";
export var profileDropdown = "_c-n";
export var profileImage = "_c-l";
export var profileMain = "_c-o";
export var profileSubtitle = "_c-q";
export var profileTitle = "_c-p";
export var reorderIcon = "_c-r";
export var sentLine = "_c-u";
export var settingsHeader = "_c-s";
export var sidenavTextColor = "_c-y";
export var spamLine = "_c-t";
export var subitemWithTag = "_c-4";
export var supportItems = "_c-j";
export var teamText = "_c-10";
export var viewLine = "_c-x";
export var viewLineButton = "_c-w";
export var viewLineButtons = "_c-v";